import React, {useContext, useState } from 'react'
import PatientListPageTemplate from '../../../components/Templates/PatientListPageTemplate'
import { AssistantCar_API } from './AssistantCar_API'
import OrgPatientListStore from '../../../components/Modals/PrintModal/store/OrgPatientListStore'
import {AuthContext} from "../../../context/AuthContext";
import LinkCell3 from "../../../components/Pages/TablePage/Table/Cells/LinkCell3/LinkCell3";
import {formatDate, isWaiting} from "../../../utils/utils";
import IconCell from "../../../components/Pages/TablePage/Table/Cells/NewCells/IconCell/IconCell";
import EditPatientCell from '../../SystemManager/EditPatinetCell'
import QuizPatientCell from '../../SystemManager/QuizPatientCell'



function AllPatientsAssistantCar() {
  const { getAllPatients } = AssistantCar_API.patients
  const { REACT_APP_URL_PREFIX } = process.env
  const [refresh, setRefresh] = useState()
  const userId = useContext(AuthContext)?.token?.userId

  return (
    <>
      <PatientListPageTemplate
        getPatientURL={`/api/v2/verificationCenters/${userId}/patients?`}
        refresh={refresh}
        filterFieldsConf={{
			fio: true,
			date: true,
			period: true,
			org: true,
			place: true,
			// medBook: true,
			resultStudyType: true,
			center: true,
			result: true,
			base: true
		}}
		tableModel={
			{

				firstRow: [
					{title: 'ФИО', id: 'fio'},
					{title: 'Дата рождения', id: 'dob'},
					// {title: 'Мед. книжка', id: 'med_book'},
					{title: 'Обследование', id: 'result_study_type'},
					{title: 'Организация', id: 'org_name'},
					{title: 'Мед центр', id: 'med_name'},
					{title: 'Дата прохождения', id: 'date'},
					{title: 'Результат', id: 'result'},
					{title: 'Распечатать', id: ''}],
				haveToShow: [
					{
						type: 'wrapperCell', typeData: {
							cell: props =>
								<EditPatientCell  label={props.all.patient.fio}
												 patientId={props.all.patient.id}
												  resultId={props.all.id}
												 API={AssistantCar_API.allPatients}
									// payload={{ resultId: props.all._id }}
												 closeCallback={() => {
													 setRefresh(!refresh)
												 }}/>
						}
					},
					{id: 'patient', type: 'arrCell', typeData: {show: 'dob', id: 'id'}},
					// {id: 'patient', type: 'arrCell', typeData: {show: 'med_book', id: 'id'}},
					{id: 'results', type: 'arrCell', typeData: {show: 'result_study_type', id: 'id'}},
					{id: 'organization', type: 'arrCell', typeData: {show: 'name', id: 'id'}},
					{id: 'medcenter', type: 'arrCell', typeData: {show: 'name', id: 'id'}},
					{id: 'results', type: 'wrapperCell', typeData: {cell: props => <LinkCell3 linkTitle={formatDate(props.all?.results?.result_date)}/>}},
					{id: 'results', type: 'resultStatusCell', typeData: {show: 'result', id: 'id'}},
					{
						id: 'results',
						typeData: {
							cell: props => !isWaiting(props?.all?.results?.result) ? 
								<IconCell iconName={"printer"} onClick={() => OrgPatientListStore.showPrintModal( props.all.id, props.all.results.patient_id,  )}/> 
								: (props?.all?.results?.study_type && props?.all?.results?.study_type.endsWith("-очередь") ? 
									<QuizPatientCell 
										studyType={props?.all?.results?.study_type}
										patientId={props.all.patient.id}
										resultId={props.all.id}
										API={AssistantCar_API.allPatients}
										closeCallback={() => {
											setRefresh(!refresh)
										}}/>: ""),
						},
						type: 'wrapperCell'
					}
				]

			}
		}
        breadCrumbsItems={[
          { title: 'Пациенты', link: REACT_APP_URL_PREFIX + '/orgPatientList' },
          { title: 'Все', actual: true, link: REACT_APP_URL_PREFIX + '/orgPatientList' }
        ]}
      />
    </>
  )
}

export default AllPatientsAssistantCar
